class PartnerList {
    constructor() {
        this.partnersAll = document.getElementById("user_account_subscribe_all");
        this.partnersCustom = document.getElementById("user_account_subscribe_custom");

        if (!this.partnersAll || !this.partnersCustom) {
            return;
        }
        this.listHeader = document.querySelector(".js-partner-list-header");
        this.list = this.listHeader.querySelector(".js-partner-list");
        this.listButton = this.listHeader.querySelector(".js-partners-list-btn");
        this.partners = this.list.querySelectorAll(".js-all-partners input[type='checkbox']");
        this.partnersCounter = this.listHeader.querySelector(".js-partners-counter");
        this.bind();
    }

    displayListHeader() {
        if (!this.partnersCustom.checked) {
            return;
        }
        this.listHeader.classList.remove("d-n");
        this.listButton.classList.remove("open");
    }

    toggleList() {
        this.list.classList.toggle("d-n");
        this.listButton.classList.toggle("open");
    }

    hideHeaderAndList() {
        this.listHeader.classList.add("d-n");
        this.list.classList.add("d-n");
    }

    countPartners() {
        this.selectedTotal = 0;
        this.partners.forEach((checkbox) => {
            if (checkbox.checked === true) { this.selectedTotal += 1; }
        });
        this.partnersCounter.innerHTML = this.selectedTotal;
    }

    selectAllPartners() {
        this.partners.forEach((checkbox) => {
            checkbox.checked = true;
        });
        this.partnersCounter.innerHTML = this.partners.length;
    }

    removeAllPartners() {
        this.partners.forEach((checkbox) => {
            checkbox.checked = false;
        });
        this.partnersCounter.innerHTML = 0;
    }

    bind() {
        document.addEventListener("DOMContentLoaded", this.displayListHeader.bind(this));
        document.addEventListener("DOMContentLoaded", this.countPartners.bind(this));
        this.partnersAll.addEventListener("click", this.hideHeaderAndList.bind(this));
        this.partnersCustom.addEventListener("click", this.displayListHeader.bind(this));
        this.listButton.addEventListener("click", this.toggleList.bind(this));
        this.list.querySelector(".js-all-partners").addEventListener("click", this.countPartners.bind(this));
        this.list.querySelector(".js-select-all-btn").addEventListener("click", this.selectAllPartners.bind(this));
        this.list.querySelector(".js-remove-all-btn").addEventListener("click", this.removeAllPartners.bind(this));
    }
}

export default PartnerList;
